import axios from "axios";
import User from "../Models/User";
import login from "../components/Login/Login";
import {connect} from "react-redux";
import { subDays } from 'date-fns';


class Api {

    constructor() {

        this.init()

    }

    init = () => {

        let url
        switch (process.env.NODE_ENV) {
            case 'production':
                url = 'https://api.typ.com/api';
                break;
            case 'development':
                url = 'http://api.localhost/api';
                break;
            default:
                url = 'https://api.typ.com/api';
        }
        axios.defaults.baseURL = url
        axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
        if (User.token) {
            axios.defaults.headers.post['Authorization'] = 'Bearer ' + User.token;
        }
        
        // Add request interceptor for debugging
        axios.interceptors.request.use(request => {
            if (request.url.includes('mediabuying/reports-stats')) {
                console.debug('NETWORK REQUEST:', {
                    url: request.url,
                    method: request.method,
                    params: request.params,
                    paramsString: request.paramsSerializer ? request.paramsSerializer(request.params) : null
                });
            }
            return request;
        });
    }

     login = async (loginCredentials) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/login',
                data: loginCredentials,
            });

            // this.props.login(true)
            return response.data;
        } catch (error) {
            return false;
        }
    };

    check = async () => {

        const response = await axios({
            method: 'GET',
            url: '/me',
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    getRotators = async () => {
        const response = await axios({
            method: 'GET',
            url: '/rotators',
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    stats = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/stats',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    updateDemandFeed = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/demand/update',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    users = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/users',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    updateUser = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/user/update',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    createDemandFeed = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/demand/create',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }
    editDemandFeed = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/demand/edit',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }


    userGenerateApiToken = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/user/generate-api-token',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    demandSupplyFeeds = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/admin/supplydemand',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    adminKPIS = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/admin/kpis',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    demandFeeds = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/demand/all',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }



    userGetApiToken = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/user/get-api-token',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }


    userSavePostback = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/user/save-postback',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });

            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    userGetPostback = async (data) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/user/get-postback',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });

            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        }
    }


    demandPartners = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/demand/partners',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    demandClosing = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/invoices/closing',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }


    mediabuyingData = async (data) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/pull',
                params: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw new Error('Failed to fetch mediabuying data');
        }
    }


    invoices = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/invoices',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    invoice = async (id) => {
        const response = await axios({
            method: 'GET',
            url: '/invoice/'+id,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    uploadInvoice = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/invoice/upload',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token, 'Content-Type': 'multipart/form-data'}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    downloadInvoice = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/invoice/download/'+data.invoiceId,
            data: data,
            responseType: 'blob',
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })

        return response
    }

    downloadBulkInvoices = async (data) => {
        const response = await axios({
            method: 'GET',
            url: 'admin/invoices/bulk',
            params: data,
            responseType: 'blob',
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })

        return response
    }


    demandStats = async (data) => {

        const response = await axios({
            method: 'GET',
            url: '/demand/stats',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    feedPerformance = async (data) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/v2/feed-performance',
                params: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('feedPerformance error:', error);
            return false;
        }
    }

    tigerStats = async (data) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/v2/tiger/stats',
                params: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('tigerStats error:', error);
            return false;
        }
    }

    tigerHourlyStats = async (data) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/v2/tiger/hourly-stats',
                params: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('tigerHourlyStats error:', error);
            return false;
        }
    }

    tigerAdvertiserLandings = async (data) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/v2/tiger/advertiser-landings',
                params: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('tigerAdvertiserLandings error:', error);
            return false;
        }
    }

    trafficControl = async (params) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/v2/traffic-control',
                timeout: 60000,
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('trafficControl error:', error);
            // Surface the validation message (422) so the page can show it instead of a generic error.
            const body = error && error.response && error.response.data;
            if (body && typeof body === 'object' && (body.message || body.error)) {
                return {success: false, message: body.message || body.error};
            }
            return false;
        }
    }

    /** Manual re-sync of one partner for one closed day (Traffic Control). Returns {success, request, existing} or {success:false, message}. */
    trafficControlPull = async (data) => {
        try {
            const response = await axios({method: 'POST', url: '/v2/traffic-control/pull', timeout: 30000, data, headers: {'Authorization': 'Bearer ' + User.token}});
            return response.data;
        } catch (error) {
            const body = error && error.response && error.response.data;
            if (body && typeof body === 'object' && (body.message || body.error)) return {success: false, message: body.message || body.error};
            return {success: false, message: 'network error'};
        }
    }

    /** Re-sync requests of the last 24 h (status chips). */
    trafficControlPulls = async () => {
        try {
            const response = await axios({method: 'GET', url: '/v2/traffic-control/pulls', timeout: 30000, headers: {'Authorization': 'Bearer ' + User.token}});
            return response.data;
        } catch (error) {
            return {success: false, requests: []};
        }
    }

    updateDemandStats = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/demand/update/stats',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    createDemandStats = async (data) => {
        console.log(data)
        const response = await axios({
            method: 'POST',
            url: '/demandstats/create',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    createDemandStatsCSV = async (data) => {
        console.log(data)
        const response = await axios({
            method: 'POST',
            url: '/demandstats/createCSV',
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }



    updateDemandClosing = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/invoices/closing/update',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    bulkUpdateDemandClosing = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/invoices/closing/bulk-update',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    updateInvoice = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/invoices/update',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    storeBillingInfo = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/billing/billinginfo/store',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    storePaymentMethod = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/billing/paymentmethod/store',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    markAsDefaultPaymentMethod = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/billing/paymentmethod/markasdefault',
            headers: {'Authorization': 'Bearer ' + User.token},
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    markAsDefaultBillingInfo = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/billing/billinginfo/markasdefault',
            headers: {'Authorization': 'Bearer ' + User.token},
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    deleteBillingInfo = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/billing/billinginfo/delete',
            headers: {'Authorization': 'Bearer ' + User.token},
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }


    invoiceMarkAsPaid = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/invoice/paid',
            headers: {'Authorization': 'Bearer ' + User.token},
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    invoiceMarkAsXP = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/invoice/xp',
            headers: {'Authorization': 'Bearer ' + User.token},
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }


    addNoteFeedAlert = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/admin/alerts/addnote',
            headers: {'Authorization': 'Bearer ' + User.token},
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    deletePaymentMethod = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/billing/paymentmethod/delete',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    supplyStore = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/supply/store',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    supplyDemandStore = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/supplydemand/store',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    supplyDemandUpdate = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/supplydemand/update',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    supplyUpdate = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/supply/update',
            data: data,
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {

            return response.data
        })

        return response
    }

    indexBillingInfos = async (data) => {

        const response = await axios({
            method: 'GET',
            url: '/billing/billinginfos',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    indexPaymentMethods = async (data) => {

        const response = await axios({
            method: 'GET',
            url: '/billing/paymentmethods',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }



    supplyPartners = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/supply/partners',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    keywordsList = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/supply/keywordsLists',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    demand = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/demand',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }
    demandTypes = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/demand/types',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    supply = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/supply',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    listSpinSupplyFeeds = async (params = {}) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/spin/feeds',
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    };

    publishSpinSupplyFeed = async (id, data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/spin/feeds/${id}/publish`,
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    }

    pauseSpinSupplyFeed = async (id) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/spin/feeds/${id}/pause`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    }

    resumeSpinSupplyFeed = async (id) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/spin/feeds/${id}/resume`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    }

    updateSpinSupplyFeedCap = async (id,data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/spin/feeds/${id}/cap`,
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    }

    createSpinSupplyFeed = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/spin/feeds',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    };

    supplydemand = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/supplydemand',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    adminSupply = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/admin/supply',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    supplyKeywords = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/supply/keywords',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    supplyDemandDetails = async (params) => {
        const response = await axios({
            method: 'GET',
            url: '/supplydemand/details',
            params: params,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }


    adminAlerts = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/admin/alerts',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    checker = async (data) => {
        const response = await axios({
            method: 'GET',
            url: '/checker',
            params: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    static async checker(params) {
        const response = await fetch('/api/checker', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params)
        });
        return await response.json();
    }

    getKeywordLists = async (includeStats = false) => {
        const response = await axios({
            method: 'GET',
            url: '/supply-feed-keywords',
            params: { include_stats: includeStats },
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    getKeywordList = async (id) => {
        const response = await axios({
            method: 'GET',
            url: `/supply-feed-keywords/${id}`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    createKeywordList = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/supply-feed-keywords',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response.data
        })

        return response
    }

    updateSpinSupplyFeedKeywords = async (feedId, data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/spin/feeds/${feedId}/keywords`,
                data: data,
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            return response.data;
        } catch (error) {
            console.error("Error updating feed keywords:", error);
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    }

    updateSpinFeedDevice = async (feedId, data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/spin/feeds/${feedId}/device`,
                data: data,
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            return response.data;
        } catch (error) {
            console.error("Error updating feed device:", error);
            return error.response ? error.response.data : { error: 'Unknown error occurred' };
        }
    }

    getMediabuyingReports = async (dateRange = {}, groupBy = 'sub_id', filters = [], sortOptions = {}) => {
        try {
            const { startDate, endDate } = dateRange;
            
            // Format dates for API if they exist
            const params = {
                group_by: groupBy
            };
            
            // Log the raw date objects
            console.debug('API getMediabuyingReports raw date objects:', {
                startDate: startDate instanceof Date ? startDate.toString() : startDate,
                endDate: endDate instanceof Date ? endDate.toString() : endDate
            });
            
            // Check if startDate is a valid Date object
            if (startDate && startDate instanceof Date && !isNaN(startDate.getTime())) {
                // Format date as YYYY-MM-DD
                const year = startDate.getFullYear();
                const month = String(startDate.getMonth() + 1).padStart(2, '0');
                const day = String(startDate.getDate()).padStart(2, '0');
                params.start_date = `${year}-${month}-${day}`;
            } else if (startDate) {
                console.error('Invalid startDate:', startDate);
            }
            
            // Check if endDate is a valid Date object
            if (endDate && endDate instanceof Date && !isNaN(endDate.getTime())) {
                // Format date as YYYY-MM-DD
                const year = endDate.getFullYear();
                const month = String(endDate.getMonth() + 1).padStart(2, '0');
                const day = String(endDate.getDate()).padStart(2, '0');
                params.end_date = `${year}-${month}-${day}`;
            } else if (endDate) {
                console.error('Invalid endDate:', endDate);
            }
            
            // Log the formatted date parameters
            console.debug('API getMediabuyingReports formatted date parameters:', {
                originalStartDate: startDate instanceof Date ? startDate.toString() : startDate,
                originalEndDate: endDate instanceof Date ? endDate.toString() : endDate,
                formattedStartDate: params.start_date,
                formattedEndDate: params.end_date
            });
            
            // Add sorting options if provided
            if (sortOptions && sortOptions.field) {
                params.sort_by = sortOptions.field;
                params.sort_dir = sortOptions.direction || 'desc';
            }
            
            // Add filters if provided
            if (filters && filters.length > 0) {
                params.filters = filters;
            }
            
            // Final log of params right before API call
            console.debug('FINAL API PARAMS:', {
                params,
                dateRange,
                startDate: dateRange.startDate instanceof Date ? dateRange.startDate.toString() : dateRange.startDate,
                endDate: dateRange.endDate instanceof Date ? endDate.toString() : endDate
            });
            
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/reports-stats',
                params,
                headers: {'Authorization': 'Bearer ' + User.token},
                paramsSerializer: params => {
                    // Custom serializer to handle nested objects and arrays
                    return Object.keys(params).map(key => {
                        if (key === 'filters' && Array.isArray(params[key])) {
                            return `filters=${encodeURIComponent(JSON.stringify(params[key]))}`;
                        }
                        return `${key}=${encodeURIComponent(params[key])}`;
                    }).join('&');
                }
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch media buying reports:', error);
            throw new Error('Failed to fetch media buying reports');
        }
    }

    // Get all Taboola campaigns with their status
    getCampaigns = async (forceRefresh = false) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/campaigns',
                headers: {'Authorization': 'Bearer ' + User.token},
                params: {
                    account_id: 'tnetwork-exm1-sc', // Use the correct account ID
                    force_refresh: forceRefresh ? 1 : 0  // Add force_refresh parameter 
                }
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch campaigns:', error);
            throw error;
        }
    }

    // Pause a Taboola campaign
    pauseCampaign = async (campaignId) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/campaigns/${campaignId}/pause`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: {
                    account_id: 'tnetwork-exm1-sc' // Use the correct account ID for all operations
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to pause campaign ${campaignId}:`, error);
            throw error;
        }
    }

    // Activate a Taboola campaign
    activateCampaign = async (campaignId) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/campaigns/${campaignId}/activate`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: {
                    account_id: 'tnetwork-exm1-sc' // Use the correct account ID for all operations
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to activate campaign ${campaignId}:`, error);
            throw error;
        }
    }

    // Get blacklist entries with optional filtering and pagination
    getBlacklist = async (params = {}) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/traffic-mixer/blacklist',
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch blacklist:', error);
            throw new Error('Failed to fetch blacklist');
        }
    }

    // Add a new entry to the blacklist
    addToBlacklist = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/traffic-mixer/blacklist/add',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Failed to add to blacklist:', error);
            throw error;
        }
    }

    // Remove an entry from the blacklist
    removeFromBlacklist = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/traffic-mixer/blacklist/remove',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Failed to remove from blacklist:', error);
            throw error;
        }
    }

    // Check if a combination is blacklisted
    checkBlacklistStatus = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/traffic-mixer/blacklist/check',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Failed to check blacklist status:', error);
            throw error;
        }
    }

    // Bulk add entries to the blacklist
    bulkAddToBlacklist = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/traffic-mixer/blacklist/bulk-add',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Failed to bulk add to blacklist:', error);
            throw error;
        }
    }

    // Get country caps data
    getCountryCaps = async () => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/country-caps',
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Failed to fetch country caps:', error);
            throw new Error('Failed to fetch country caps');
        }
    }

    // RSOC Pages - Generate content using ads.com API
    generateRsocPage = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages/generate',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error generating RSOC page:', error);
            throw error;
        }
    }
    
    // RSOC Pages - Generate content using OpenAI API
    generateRsocPageWithOpenAI = async (data) => {
        try {
            console.log('Generating content with OpenAI:', data);
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages/generate-openai',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error generating RSOC page with OpenAI:', error);
            throw error;
        }
    }
    
    // Edit image using OpenAI's image editing API
    editImageWithOpenAI = async (data) => {
        try {
            console.log('Editing image with OpenAI:', data);
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages/edit-image',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error editing image with OpenAI:', error);
            throw error;
        }
    }
    
    // RSOC Pages - Store generated content using ads.com API
    storeRsocPage = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error storing RSOC page:', error);
            throw error;
        }
    }

    // RSOC Pages - Delete an RSOC page
    deleteRsocPage = async (rsocPageId) => {
        try {
            const response = await axios({
                method: 'DELETE',
                url: `/ads/rsoc-pages/${rsocPageId}`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting RSOC page:', error);
            throw error;
        }
    }

    // Facebook Campaign Creation
    createFacebookCampaign = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/admin/mediabuying/facebook-campaigns',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error creating Facebook campaign:', error);
            throw error;
        }
    }

    createFacebookAdSet = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/admin/mediabuying/facebook-adsets',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error creating Facebook ad set:', error);
            throw error;
        }
    }

    createFacebookAd = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/admin/mediabuying/facebook-ads',
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error creating Facebook ad:', error);
            throw error;
        }
    }

    // Search domains in ads.com
    searchDomains = async (params = {}) => {
        try {
            const defaultParams = {
                order_by: [
                    {
                        column: "domain_name",
                        order: "asc"
                    }
                ],
                page: 1,
                per_page: 100
            };
            
            const searchParams = { ...defaultParams, ...params };
            
            const response = await axios({
                method: 'POST',
                url: '/ads/domain/search',
                data: searchParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            
            return response.data;
        } catch (error) {
            console.error('Error searching domains:', error);
            throw error;
        }
    }
    
    // Search verticals (categories) in ads.com
    searchVerticals = async (params = {}) => {
        try {
            const defaultParams = {

                order_by: [
                    {
                        column: "name",
                        order: "asc"
                    }
                ],
                page: 1,
                per_page: 100
            };

            const searchParams = { ...defaultParams, ...params };

            const response = await axios({
                method: 'POST',
                url: '/ads/verticals/search',
                data: searchParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });

            return response.data;
        } catch (error) {
            console.error('Error searching verticals:', error);
            throw error;
        }
    }

    // Get categories from local database (faster alternative to searchVerticals)
    getLocalCategories = async (params = {}) => {
        try {
            const queryParams = new URLSearchParams({
                all: params.all !== undefined ? params.all : true, // Default to all categories
                ...(params.page && { page: params.page }),
                ...(params.per_page && { per_page: params.per_page }),
                ...(params.search && { search: params.search })
            });

            const response = await axios({
                method: 'GET',
                url: `/ads/rsoc/categories?${queryParams}`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });

            // Format response to match searchVerticals format
            return {
                success: response.data.success,
                data: response.data.data,
                total: response.data.total,
                pagination: response.data.pagination
            };
        } catch (error) {
            console.error('Error getting local categories:', error);
            throw error;
        }
    }

    // RSOC Pages - Get all RSOC pages with optional filtering
    getRsocPages = async (params = {}) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/ads/rsoc-pages',
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching RSOC pages:', error);
            return { error: error.message, rsoc_pages: { data: [] } };
        }
    }

    getRsocSpyPages = async (params = {}) => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/ads/rsoc-spy-pages',
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching RSOC spy pages:', error);
            return { error: error.message, rsoc_pages: { data: [] } };
        }
    }

    updateRsocSpyCampaignId = async (rsocSpyId, campaignId) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-spy-pages/update-campaign-id',
                data: {
                    rsoc_spy_id: rsocSpyId,
                    campaign_id: campaignId
                },
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error updating RSOC spy campaign ID:', error);
            return { success: false, error: error.message };
        }
    }

    // Get RSOC channel warnings (missing channels for knowledgia, duplicate channels)
    getRsocChannelWarnings = async () => {
        try {
            const response = await axios({
                method: 'GET',
                url: '/ads/rsoc/channel-warnings',
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching RSOC channel warnings:', error);
            return { success: false, error: error.message };
        }
    }

    // Campaign Channel Report - Get campaign stats by date range
    getCampaignChannelReport = async (params = {}) => {
        try {
            const { domain_name, start_date, end_date } = params;
            
            // Validate required parameters
            if (!domain_name || !start_date || !end_date) {
                throw new Error('Missing required parameters: domain_name, start_date, and end_date are required');
            }

            const formattedParams = {
                domain_name,
                start_date: start_date instanceof Date ? this.formatDate(start_date) : start_date,
                end_date: end_date instanceof Date ? this.formatDate(end_date) : end_date
            };
            
            const response = await axios({
                method: 'POST',
                url: '/ads/reports/rsoc/campaigns/date',
                data: formattedParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            
            return response.data;
        } catch (error) {
            console.error('Error fetching campaign channel report:', error);
            throw error;
        }
    }
    
    // Parking Events - Get parked domain event data
    getParkingEvents = async (params = {}) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/reports/parking-events',
                data: params,
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error fetching parking events:', error);
            throw error;
        }
    }
    
    // Parking Events Hourly - Get parked domain event data grouped by hour
    getParkingEventsHourly = async (params = {}) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/reports/parking-events-hourly',
                data: params,
                headers: { 'Authorization': 'Bearer ' + User.token }
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching hourly parking events:', error);
            throw error;
        }
    }

    // Compado By Campaign - Get Compado click data grouped by campaign_id
    getCompadoByCampaign = async (params = {}) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/reports/compado-by-campaign',
                data: params,
                headers: { 'Authorization': 'Bearer ' + User.token }
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching Compado campaign data:', error);
            throw error;
        }
    }

    getPerformanceReport = async (params = {}) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/reports/performance',
                data: params,
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error fetching parking events report:', error);
            throw error;
        }
    }

    // Helper method to format dates consistently
    formatDate = (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    
    // Helper method to format date with time
    formatDateTime = (date) => {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    // Helper method to get today at midnight
    getTodayStart = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    }
    
    // Helper method to get today at 23:59:59
    getTodayEnd = () => {
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        return today;
    }

    // Get Taboola campaign metrics for tnetwork-exm1-sc account
    getTaboolaCampaignMetrics = async (startDate, endDate) => {
        try {
            const formattedParams = {
                start_date: startDate instanceof Date ? this.formatDate(startDate) : startDate,
                end_date: endDate instanceof Date ? this.formatDate(endDate) : endDate,
                account_id: 'tnetwork-exm1-sc' // Use the specific account ID
            };
            
            console.debug('Fetching Taboola campaign metrics with params:', formattedParams);
            
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/taboola-metrics',
                params: formattedParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            
            return response.data;
        } catch (error) {
            console.error('Failed to fetch Taboola campaign metrics:', error);
            throw new Error('Failed to fetch Taboola campaign metrics');
        }
    }

    // Get Facebook campaign metrics
    getFacebookCampaignMetrics = async (startDate, endDate, forceRefresh = false, account_id) => {
        try {
            // Build base parameters
            const formattedParams = {
                start_date: startDate instanceof Date ? this.formatDate(startDate) : startDate,
                end_date: endDate instanceof Date ? this.formatDate(endDate) : endDate,
            };
            
            // Only include account_id if it's provided and not the default
            if (account_id && account_id !== 'default_account_id') {
                formattedParams.account_id = account_id;
                console.debug(`Using provided account_id: ${account_id}`);
            }
            
            // Add force_refresh parameter if true
            if (forceRefresh) {
                formattedParams.force_refresh = "1";
            }
            
            console.debug('Fetching Facebook campaign metrics with params:', formattedParams);
            
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/facebook-metrics',
                params: formattedParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            
            // Log the detailed response for debugging
            console.debug('Facebook metrics API response:', {
                success: response.data.success,
                dataCount: response.data.data ? response.data.data.length : 0,
                sampleData: response.data.data && response.data.data.length > 0 
                    ? response.data.data.slice(0, 1)
                    : 'No data'
            });
            
            // Check if the response contains data with spent field
            if (response.data.data && response.data.data.length > 0) {
                const hasBudgetInfo = response.data.data.some(item => {
                    const hasSpent = item.spent !== undefined && item.spent !== null;
                    const hasDailyBudget = item.daily_budget !== undefined && item.daily_budget !== null;
                    
                    if (hasSpent) {
                        console.debug(`Campaign ${item.campaign_id} has spent value: ${item.spent}`);
                    } else {
                        console.debug(`Campaign ${item.campaign_id} MISSING spent value`);
                    }
                    
                    if (hasDailyBudget) {
                        console.debug(`Campaign ${item.campaign_id} has daily_budget value: ${item.daily_budget}`);
                    }
                    
                    return hasSpent || hasDailyBudget;
                });
                
                console.debug(`Facebook response has budget info: ${hasBudgetInfo}`);
            }
            
            return response.data;
        } catch (error) {
            console.error('Error fetching Facebook campaign metrics:', error);
            return {
                success: false,
                error: error.message || 'Error fetching Facebook campaign metrics'
            };
        }
    }

    // Get AdSense campaign stats (real-time from AdSense API)
    getAdSenseCampaignStats = async (startDate, endDate) => {
        try {
            const formattedParams = {
                start_date: startDate instanceof Date ? this.formatDate(startDate) : startDate,
                end_date: endDate instanceof Date ? this.formatDate(endDate) : endDate,
            };

            console.debug('Fetching AdSense campaign stats with params:', formattedParams);

            const response = await axios({
                method: 'GET',
                url: '/adsense/campaigns/stats',
                params: formattedParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });

            console.debug('AdSense stats API response:', {
                success: response.data.success,
                dataCount: response.data.data ? response.data.data.length : 0
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching AdSense campaign stats:', error);
            return {
                success: false,
                error: error.message || 'Error fetching AdSense campaign stats',
                data: []
            };
        }
    }

    // Get all Facebook campaigns
    getFacebookCampaigns = async (forceRefresh = false, account_id, options = {}) => {
        try {
            // Build parameters object
            const params = {
                force_refresh: forceRefresh ? 1 : 0
            };
            
            // Only add account_id parameter if it's provided and not the default
            if (account_id && account_id !== 'default_account_id') {
                params.account_id = account_id;
                console.log(`Fetching Facebook campaigns with forceRefresh=${forceRefresh} and account_id=${account_id}`);
            } else {
                console.log(`Fetching Facebook campaigns with forceRefresh=${forceRefresh} using server-configured account_id`);
            }
            
            // Add filtering options for better performance
            if (options.onlyActive !== false) {
                // By default, only fetch campaigns with recent activity (last 30 days)
                params.only_active = 1;
                
                // Set activity window (default to 30 days)
                const activityDays = options.activityDays || 30;
                params.activity_days = activityDays;
                
                console.log(`Filtering for campaigns with activity in the last ${activityDays} days`);
            }
            
            // Add limit parameter for pagination (default to 500 to avoid timeouts)
            if (options.limit) {
                params.limit = options.limit;
            } else {
                params.limit = 500; // Reasonable default to avoid timeouts
            }
            
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/facebook-campaigns',
                headers: {'Authorization': 'Bearer ' + User.token},
                params: params
            });
            
            // Log the response structure for debugging
            if (response.data && response.data.results) {
                console.log(`Received ${response.data.results.length} Facebook campaigns from API`);
                
                // Check how many campaigns have budget information
                const budgetStats = {
                    withDailyBudget: 0,
                    withLifetimeBudget: 0,
                    withSpendCap: 0,
                    noBudget: 0
                };
                
                response.data.results.forEach(campaign => {
                    if (campaign.daily_budget !== null && campaign.daily_budget !== undefined) 
                        budgetStats.withDailyBudget++;
                    if (campaign.lifetime_budget !== null && campaign.lifetime_budget !== undefined) 
                        budgetStats.withLifetimeBudget++;
                    if (campaign.spend_cap !== null && campaign.spend_cap !== undefined) 
                        budgetStats.withSpendCap++;
                    if ((campaign.daily_budget === null || campaign.daily_budget === undefined) && 
                        (campaign.lifetime_budget === null || campaign.lifetime_budget === undefined) &&
                        (campaign.spend_cap === null || campaign.spend_cap === undefined)) 
                        budgetStats.noBudget++;
                });
                
                console.log('Facebook campaigns budget stats:', budgetStats);
            }
            
            return response.data;
        } catch (error) {
            console.error('Failed to fetch Facebook campaigns:', error);
            throw error;
        }
    }

    // Get details for a specific Facebook campaign
    getFacebookCampaignDetails = async (campaignId, accountId) => {
        try {
            console.debug(`Fetching Facebook campaign details for: ${campaignId}`);
            
            // Build the params object
            const params = {
                include_adsets: true  // Request to include adset data if possible
            };
            
            // Only add account_id if it's valid
            if (accountId && accountId !== 'default_account_id') {
                params.account_id = accountId;
            }
            
            const response = await axios({
                method: 'GET',
                url: `/admin/mediabuying/facebook-campaigns/${campaignId}`,
                headers: {'Authorization': 'Bearer ' + User.token},
                params: params
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to fetch details for Facebook campaign ${campaignId}:`, error);
            return {
                success: false,
                error: error.message || 'Failed to fetch Facebook campaign details'
            };
        }
    }

    // Pause a Facebook campaign
    pauseFacebookCampaign = async (campaignId, accountId) => {
        try {
            // Build data object to send
            const data = {};
            
            // Only add account_id if it's valid
            if (accountId && accountId !== 'default_account_id') {
                data.account_id = accountId;
            }
            
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/facebook-campaigns/${campaignId}/pause`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: data
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to pause Facebook campaign ${campaignId}:`, error);
            throw error;
        }
    }

    // Activate a Facebook campaign
    activateFacebookCampaign = async (campaignId, accountId) => {
        try {
            // Build data object to send
            const data = {};
            
            // Only add account_id if it's valid
            if (accountId && accountId !== 'default_account_id') {
                data.account_id = accountId;
            }
            
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/facebook-campaigns/${campaignId}/activate`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: data
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to activate Facebook campaign ${campaignId}:`, error);
            throw error;
        }
    }

    // Get Facebook adset budgets for a campaign
    getFacebookAdsetBudgets = async (campaignId, accountId = process.env.REACT_APP_FB_ACCOUNT_ID || 'default_account_id') => {
        try {
            const response = await axios({
                method: 'GET',
                url: `/admin/mediabuying/facebook-campaigns/${campaignId}/adsets/budgets`,
                headers: {'Authorization': 'Bearer ' + User.token},
                params: {
                    account_id: accountId
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to fetch adset budgets for campaign ${campaignId}:`, error);
            return {
                success: false,
                error: error.message || 'Failed to fetch adset budgets'
            };
        }
    }

    // Update a Facebook campaign budget
    updateFacebookCampaignBudget = async (campaignId, budget, accountId) => {
        try {
            // Build data object to send
            const data = {
                budget: budget
            };
            
            // Only add account_id if it's valid
            if (accountId && accountId !== 'default_account_id') {
                data.account_id = accountId;
            }
            
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/facebook-campaigns/${campaignId}/budget`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: data
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to update budget for Facebook campaign ${campaignId}:`, error);
            throw error;
        }
    }

    // Update a Taboola campaign budget
    updateCampaignBudget = async (campaignId, budget, accountId = 'tnetwork-exm1-sc') => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/campaigns/${campaignId}/budget`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: {
                    budget: budget,
                    account_id: accountId // Pass the account ID to the backend
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Failed to update campaign budget for ${campaignId}:`, error);
            throw error;
        }
    }

    // Blacklist a subid3 in a Taboola campaign
    blacklistSubid3 = async (subid3, subid2, accountId = 'tnetwork-exm1-sc') => {
        try {
            console.log(`Blacklisting subid3 ${subid3} from campaign ${subid2}`);
            
            // Call the Taboola API to add the site to the blacklist
            // According to Taboola docs, we need to call the site blacklist endpoint
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/campaigns/blacklist-site`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: {
                    account_id: accountId,
                    campaign_id: subid2, // The campaign ID where to add the blacklist
                    site: subid3,        // The subid3 to blacklist
                    is_permanent: true   // Make it a permanent blacklist
                }
            });
            
            // Log success and return response
            console.log(`Successfully blacklisted subid3 ${subid3} from campaign ${subid2}`);
            return response.data;
        } catch (error) {
            console.error(`Failed to blacklist subid3 ${subid3}:`, error);
            throw error;
        }
    }

    // Get the blacklisted sites for a Taboola campaign
    getTaboolaCampaignBlacklist = async (campaignId, accountId = 'tnetwork-exm1-sc') => {
        try {
            console.log(`Fetching blacklist for campaign ${campaignId}`);
            const response = await axios({
                method: 'GET',
                url: `/admin/mediabuying/campaigns/${campaignId}/blacklist`,
                headers: {'Authorization': 'Bearer ' + User.token},
                params: {
                    account_id: accountId
                }
            });
            
            console.log('Blacklist API response:', response.data);
            return response.data;
        } catch (error) {
            console.error(`Failed to get blacklist for campaign ${campaignId}:`, error);
            throw error;
        }
    }

    // Remove a subid3 from a Taboola campaign's blacklist
    unblacklistSubid3 = async (subid3, subid2, accountId = 'tnetwork-exm1-sc') => {
        try {
            console.log(`Removing subid3 ${subid3} from blacklist for campaign ${subid2}`);
            
            // Call the API to remove the site from the blacklist
            const response = await axios({
                method: 'POST',
                url: `/admin/mediabuying/campaigns/unblacklist-site`,
                headers: {'Authorization': 'Bearer ' + User.token},
                data: {
                    account_id: accountId,
                    campaign_id: subid2, // The campaign ID where to remove from blacklist
                    site: subid3         // The subid3 to unblacklist
                }
            });
            
            // Inspect the response to see if the site is still in the blacklist
            const data = response.data;
            console.log('Full unblacklist response data:', data);
            
            // Check for special workaround response for Taboola API limitations
            if (data && data.success) {
                if (data.workaround) {
                    console.log('Detected Taboola API limitation workaround in response');
                    return {
                        ...data,
                        // Add our own field to inform frontend the site should be treated as removed
                        _siteRemoved: true,
                        _needsRefresh: true
                    };
                }
                
                if (data.pending) {
                    console.log('Detected pending unblacklist operation that needs manual refresh');
                    return {
                        ...data,
                        // Add our own field to inform frontend the site should be treated as removed
                        _siteRemoved: true,
                        _needsRefresh: true
                    };
                }
                
                // Check the actual data structure in a normal success case
                if (data.data && 
                    data.data.publisher_targeting && 
                    data.data.publisher_targeting.type === 'EXCLUDE' && 
                    Array.isArray(data.data.publisher_targeting.value)) {
                    
                    // Check if the site is still in the blacklist
                    const stillBlacklisted = data.data.publisher_targeting.value.includes(subid3);
                    
                    if (stillBlacklisted) {
                        console.warn(`WARN: Site ${subid3} is still in the blacklist after unblacklist operation!`);
                        
                        // Return with a special flag for the frontend to handle
                        return {
                            ...data,
                            _siteRemoved: false,
                            _stillBlacklisted: true
                        };
                    } else {
                        console.log(`SUCCESS: Site ${subid3} was successfully removed from the blacklist!`);
                        return {
                            ...data,
                            _siteRemoved: true
                        };
                    }
                } else if (!data.data.publisher_targeting) {
                    console.log(`No publisher_targeting found in response, site should be unblacklisted successfully`);
                    return {
                        ...data,
                        _siteRemoved: true
                    };
                }
            }
            
            // Default response
            console.log(`Unblacklist API call completed for ${subid3} from campaign ${subid2}`);
            return response.data;
        } catch (error) {
            console.error(`Failed to remove subid3 ${subid3} from blacklist:`, error);
            throw error;
        }
    }

    // Get Taboola campaign site metrics for a specific campaign
    getTaboolaCampaignSiteMetrics = async (campaignId, startDate, endDate, accountId = 'tnetwork-exm1-sc') => {
        try {
            const formattedParams = {
                start_date: startDate instanceof Date ? this.formatDate(startDate) : startDate,
                end_date: endDate instanceof Date ? this.formatDate(endDate) : endDate,
                campaign_id: campaignId,
                account_id: accountId
            };
            
            console.debug('Fetching Taboola site metrics with params:', formattedParams);
            console.debug('API URL:', '/admin/mediabuying/taboola-site-metrics');
            
            // Log the full URL being constructed
            const queryString = Object.entries(formattedParams)
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join('&');
            console.debug('Full URL with params: /admin/mediabuying/taboola-site-metrics?' + queryString);
            
            const response = await axios({
                method: 'GET',
                url: '/admin/mediabuying/taboola-site-metrics',
                params: formattedParams,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            
            // Log more details about the response
            if (response.data && response.data.success) {
                console.debug('Taboola site metrics response successful:', {
                    siteCount: response.data.sites ? response.data.sites.length : 0,
                    firstSite: response.data.sites && response.data.sites.length > 0 ? response.data.sites[0] : null
                });
            } else {
                console.warn('Taboola site metrics response not successful:', response.data);
            }
            
            return response.data;
        } catch (error) {
            console.error('Failed to fetch Taboola site metrics:', error);
            // Log additional details about the error
            if (error.response) {
                console.error('Response status:', error.response.status);
                console.error('Response data:', error.response.data);
            }
            throw new Error('Failed to fetch Taboola site metrics: ' + error.message);
        }
    }

    // Create a complete Facebook campaign with ad set and ads
    createCompleteFacebookCampaign = async (campaignData) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/admin/mediabuying/facebook-campaigns/complete',
                headers: {'Authorization': 'Bearer ' + User.token},
                data: campaignData
            });
            return response.data;
        } catch (error) {
            console.error('Failed to create complete Facebook campaign:', error);
            throw error;
        }
    }

    // Get preloaded images for a specific slug
    getRsocPageImages = async (slug) => {
        try {
            console.log(`API service: Fetching images for slug: ${slug}`);
            const response = await axios({
                method: 'GET',
                url: `/ads/rsoc-pages/images/${slug}`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            
            console.log('API response for images:', response.data);
            return response.data;
        } catch (error) {
            console.error('Error fetching preloaded images:', error);
            return { success: false, error: error.message, data: [] };
        }
    }

    // RSOC Pages - Check if a page has generated images
    getRsocPageImageStatus = async (pageId, slug = null) => {
        try {
            // If slug is provided, use it directly in the URL to ensure we're looking in the correct folder
            const endpoint = slug 
                ? `/ads/rsoc-pages/${pageId}/image-status?slug=${encodeURIComponent(slug)}` 
                : `/ads/rsoc-pages/${pageId}/image-status`;
                
            const response = await axios({
                method: 'GET',
                url: endpoint,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error checking RSOC page image status:', error);
            return { success: false, error: error.message };
        }
    }
    
    // RSOC Pages - Regenerate images for a page
    regenerateRsocPageImages = async (pageId, title = null, slug = null) => {
        try {
            // Add title and slug as query parameters if provided
            const params = {};
            if (title) params.title = title;
            if (slug) params.slug = slug;

            const response = await axios({
                method: 'POST',
                url: `/ads/rsoc-pages/${pageId}/regenerate-images`,
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error regenerating RSOC page images:', error);
            return { success: false, error: error.message };
        }
    }

    // Generate video ads for RSOC page
    generateRsocPageVideo = async (pageSlug, pageTitle, versions = 3) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages/generate-video',
                data: {
                    page_slug: pageSlug,
                    page_title: pageTitle,
                    versions: versions
                },
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            return response.data;
        } catch (error) {
            console.error('Error generating video:', error);
            throw error;
        }
    }

    // Generate keyword suggestions based on high-performing terms
    generateKeywordSuggestions = async (highPerformingTerms) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages/keyword-suggestions',
                data: {
                    high_performing_terms: highPerformingTerms
                },
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error generating keyword suggestions:', error);
            throw error;
        }
    }

    // Generate 3 intelligent keywords for a specific title using OpenAI
    generateKeywordsForTitle = async (title, highPerformingTerms, context = 'content') => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc-pages/generate-keywords-for-title',
                data: {
                    title: title,
                    high_performing_terms: highPerformingTerms,
                    context: context
                },
                headers: { 'Authorization': 'Bearer ' + User.token }
            });
            
            return response.data;
        } catch (error) {
            console.error('Error generating keywords for title:', error);
            throw error;
        }
    }

    /**
     * Get Facebook accounts configuration from backend
     * @param {string} feature - Optional: 'launcher', 'analytics', or 'all'
     */
    getFacebookAccounts = async (feature = 'all') => {
        const response = await axios({
            method: 'GET',
            url: '/facebook/accounts',
            params: { feature },
            headers: {'Authorization': 'Bearer ' + User.token}
        })
        return response
    }

    // Media buying rules logs
    getRulesLogs = async (params = {}) => {
        const response = await axios({
            method: 'GET',
            url: '/admin/mediabuying/rules-logs',
            params: params,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    // Rules management endpoints
    getRules = async () => {
        const response = await axios({
            method: 'GET',
            url: '/admin/mediabuying/rules',
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    getRule = async (id) => {
        const response = await axios({
            method: 'GET',
            url: `/admin/mediabuying/rules/${id}`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    createRule = async (data) => {
        const response = await axios({
            method: 'POST',
            url: '/admin/mediabuying/rules',
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    updateRule = async (id, data) => {
        const response = await axios({
            method: 'PUT',
            url: `/admin/mediabuying/rules/${id}`,
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    deleteRule = async (id) => {
        const response = await axios({
            method: 'DELETE',
            url: `/admin/mediabuying/rules/${id}`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    toggleRule = async (id) => {
        const response = await axios({
            method: 'POST',
            url: `/admin/mediabuying/rules/${id}/toggle`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    getRuleSchema = async () => {
        const response = await axios({
            method: 'GET',
            url: '/admin/mediabuying/rules-schema',
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            return false
        }).then(function (response) {
            return response
        })
        return response
    }

    /**
     * Get recommended articles from ads.com
     * @param {Object} params - Parameters (page, per_page, tag)
     * @returns {Promise} Response with articles data
     */
    getRecommendedArticles = async (params = {}) => {
        const { page = 1, per_page = 12, tag = 'rpm-trending-by-domains' } = params;
        
        const response = await axios({
            method: 'POST',
            url: '/ads/rsoc/recommended-articles',
            data: {
                page,
                per_page,
                filter_by: [
                    {
                        column: 'tag',
                        operator: '=',
                        value: tag
                    }
                ],
                order_by: [
                    {
                        column: 'created_at',
                        order: 'desc'
                    }
                ]
            },
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            throw error;
        }).then(function (response) {
            return response.data;
        })
        return response
    }

    /**
     * Get a single recommended article from ads.com
     * @param {number} id - Article ID
     * @returns {Promise} Response with article data
     */
    getRecommendedArticle = async (id) => {
        const response = await axios({
            method: 'GET',
            url: `/ads/rsoc/recommended-articles/${id}`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            throw error;
        }).then(function (response) {
            return response.data;
        })
        return response
    }

    /**
     * Get RSOC article data for an article
     * @param {number} id - Article ID
     * @returns {Promise} Response with article data
     */
    getRsocTemplate = async (id) => {
        const response = await axios({
            method: 'GET',
            url: `/ads/rsoc-article/${id}`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            throw error;
        }).then(function (response) {
            return response.data;
        });

        return response;
    };

    /**
     * Publish a recommended article as an RSOC page
     * @param {number} id - Article ID
     * @param {Object} data - Publication data (domain_name_id, intro, content)
     * @returns {Promise} Response with publication result
     */
    publishRecommendedArticle = async (id, data) => {
        const response = await axios({
            method: 'POST',
            url: `/ads/rsoc/recommended-articles/${id}/publish`,
            data: data,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            throw error;
        }).then(function (response) {
            return response.data;
        })
        return response
    }

    /**
     * Get the optimal Facebook page ID with fewest running ads
     * @returns {Promise} Response with optimal page ID and stats
     */
    getOptimalPageId = async () => {
        const response = await axios({
            method: 'GET',
            url: `/ads/rsoc/optimal-page-id`,
            headers: {'Authorization': 'Bearer ' + User.token}
        }).catch(function (error) {
            console.log(error);
            throw error;
        }).then(function (response) {
            return response.data;
        });

        return response;
    };

    /**
     * Validate campaign requirements before launch
     * @param {Object} data - Campaign data to validate
     * @returns {Promise} Response with validation results
     */
    validateCampaignRequirements = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/ads/rsoc/validate-campaign`,
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error validating campaign requirements:', error);
            throw error;
        }
    };

    /**
     * Get inspiration data from rsoc_spy table
     * @param {Object} params - Query parameters (page, per_page, search, category)
     * @returns {Promise} Response with inspiration data
     */
    getRsocInspiration = async (params = {}) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `/ads/rsoc/inspiration`,
                params: params,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching RSOC inspiration:', error);
            throw error;
        }
    };

    /**
     * Create manual inspiration entry
     * @param {Object} data - { title, keywords, special_ad_categories }
     * @returns {Promise} Response with created inspiration
     */
    createManualRsocInspiration = async (data) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/ads/rsoc/inspiration/manual`,
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error creating manual inspiration:', error);
            throw error;
        }
    };

    /**
     * Update category for an inspiration item
     * @param {number} id - Inspiration item ID
     * @param {string} category - New category name
     * @param {number} categoryId - Category ID from ads.com API
     * @returns {Promise} Response with update result
     */
    updateRsocInspirationCategory = async (id, category, categoryId = null) => {
        try {
            const data = { category };
            if (categoryId) {
                data.category_id = categoryId;
            }

            const response = await axios({
                method: 'PUT',
                url: `/ads/rsoc/inspiration/${id}/category`,
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error updating inspiration category:', error);
            // Try the test route as fallback
            try {
                const data = { category };
                if (categoryId) {
                    data.category_id = categoryId;
                }

                const fallbackResponse = await axios({
                    method: 'PUT',
                    url: `/ads/test/inspiration/${id}/category`,
                    data: data,
                    headers: {'Authorization': 'Bearer ' + User.token}
                });
                return fallbackResponse.data;
            } catch (fallbackError) {
                console.error('Error updating inspiration category from test route:', fallbackError);
                throw fallbackError;
            }
        }
    };

    /**
     * Delete an inspiration item
     * @param {number} id - Inspiration item ID
     * @returns {Promise} Response with delete result
     */
    deleteRsocInspiration = async (id) => {
        try {
            const response = await axios({
                method: 'DELETE',
                url: `/ads/rsoc/inspiration/${id}`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error deleting inspiration item:', error);
            // Try the test route as fallback
            try {
                const fallbackResponse = await axios({
                    method: 'DELETE',
                    url: `/ads/test/inspiration/${id}`,
                    headers: {'Authorization': 'Bearer ' + User.token}
                });
                return fallbackResponse.data;
            } catch (fallbackError) {
                console.error('Error deleting inspiration item from test route:', fallbackError);
                throw fallbackError;
            }
        }
    };

    /**
     * Upload CSV file for RSOC inspiration
     * @param {FormData} formData - Form data with CSV file
     * @returns {Promise} Response with upload results
     */
    uploadRsocInspirationCSV = async (formData) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc/inspiration/upload-csv',
                data: formData,
                headers: {
                    'Authorization': 'Bearer ' + User.token,
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 60000 // 1 minute timeout for upload (job returns immediately)
            });
            return response.data;
        } catch (error) {
            console.error('Error uploading RSOC inspiration CSV:', error);
            return { success: false, message: error.response?.data?.message || error.message };
        }
    }

    /**
     * Check status of CSV processing job
     * @param {string} jobId - Job ID returned from upload
     * @returns {Promise} Response with job status
     */
    checkCSVJobStatus = async (jobId) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `/ads/rsoc/inspiration/csv-job-status/${jobId}`,
                headers: {
                    'Authorization': 'Bearer ' + User.token
                },
                timeout: 10000 // 10 seconds timeout
            });
            return response.data;
        } catch (error) {
            console.error('Error checking CSV job status:', error);
            return { success: false, message: error.response?.data?.message || error.message };
        }
    };

    /**
     * Confirm and insert selected CSV items
     * @param {string} jobId - Job ID from CSV processing
     * @param {array} selectedItems - Array of temp_ids to insert
     * @returns {Promise} Response with insertion results
     */
    confirmCSVItems = async (jobId, selectedItems) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `/ads/rsoc/inspiration/csv-confirm/${jobId}`,
                data: { selected_items: selectedItems },
                headers: {
                    'Authorization': 'Bearer ' + User.token
                },
                timeout: 60000 // 60 seconds timeout for potentially large inserts
            });
            return response.data;
        } catch (error) {
            console.error('Error confirming CSV items:', error);
            return { success: false, message: error.response?.data?.message || error.message };
        }
    };

    updateRsocInspirationTitle = async (id, title) => {
        try {
            const response = await axios({
                method: 'PUT',
                url: `/ads/rsoc/inspiration/${id}/title`,
                data: { title },
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error updating inspiration title:', error);
            // Try the test route as fallback
            try {
                const fallbackResponse = await axios({
                    method: 'PUT',
                    url: `/ads/test/inspiration/${id}/title`,
                    data: { title },
                    headers: {'Authorization': 'Bearer ' + User.token}
                });
                return fallbackResponse.data;
            } catch (fallbackError) {
                console.error('Error updating inspiration title from test route:', fallbackError);
                throw fallbackError;
            }
        }
    };

    updateRsocInspirationKeywords = async (id, keywords) => {
        try {
            const response = await axios({
                method: 'PUT',
                url: `/ads/rsoc/inspiration/${id}/keywords`,
                data: { keywords },
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error updating inspiration keywords:', error);
            // Try the test route as fallback
            try {
                const fallbackResponse = await axios({
                    method: 'PUT',
                    url: `/ads/test/inspiration/${id}/keywords`,
                    data: { keywords },
                    headers: {'Authorization': 'Bearer ' + User.token}
                });
                return fallbackResponse.data;
            } catch (fallbackError) {
                console.error('Error updating inspiration keywords from test route:', fallbackError);
                throw fallbackError;
            }
        }
    };


    updateRsocInspirationPageId = async (id, pageId, specialAdCategories = null) => {
        try {
            const data = { page_id: pageId };
            if (specialAdCategories) {
                data.special_ad_categories = specialAdCategories;
            }

            const response = await axios({
                method: 'PUT',
                url: `/ads/rsoc/inspiration/${id}/page-id`,
                data: data,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error updating inspiration page_id:', error);
            throw error;
        }
    };

    // Generate RSOC content using background job
    generateRsocContentJob = async (rsocItem, selectedCategory, specialAdCategories = ['NONE'], defaultDomain = null) => {
        try {
            const response = await axios({
                method: 'POST',
                url: '/ads/rsoc/inspiration/generate-content',
                data: {
                    rsoc_item: rsocItem,
                    selected_category: selectedCategory,
                    special_ad_categories: specialAdCategories,
                    default_domain: defaultDomain
                },
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error starting content generation job:', error);
            throw error;
        }
    };

    // Check RSOC content generation status
    checkRsocContentStatus = async (id) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `/ads/rsoc/inspiration/${id}/status`,
                headers: {'Authorization': 'Bearer ' + User.token}
            });
            return response.data;
        } catch (error) {
            console.error('Error checking content status:', error);
            throw error;
        }
    };
}


export default new Api();